import { useMutation } from "@tanstack/react-query";
import { monthlyTrainingPlanSummaryApi } from "../../../../../services/human-organization/monthly-training-plan-summary.service";

export const useUpdateMTPS = () => {
  return useMutation({
    mutationFn: ({ id, body }: any) => {
      const updatedFields = monthlyTrainingPlanSummaryApi.toRequest(body);
      return monthlyTrainingPlanSummaryApi.update(id, updatedFields);
    },
  });
};
